import React, { useEffect } from "react";
import { Modal, Form, Input, Radio} from "antd";
import {Vacancy} from "../models/Vacancy";


interface JobApplicationModalProps {
    open: boolean;
    vacancy: Vacancy | null;
    onClose: () => void;
    onSubmitted?: () => void;
}

const JobApplicationModal: React.FC<JobApplicationModalProps> = ({ open, vacancy, onClose, onSubmitted }) => {
    const [form]     = Form.useForm();
    const [submitting, setSubmitting] = React.useState(false);

    // Reset the form whenever a different vacancy is opened
    useEffect(() => {
        if (open) form.resetFields();
    }, [open, vacancy, form]);

    const handleFinish = (values: any) => {
        if (!vacancy) return;

        {/*{const application: JobApplication = {
            vacancy_id: vacancy.id,
            full_names: values.full_names,
            surname: values.surname,
            is_sa_citizen: values.is_sa_citizen,
            id_or_passport_number: values.id_or_passport_number,
            has_drivers_licence: values.has_drivers_licence,
            address: values.address,
        };

        setSubmitting(true);
        VacancyService.submitApplication(application)
            .then(() => {
                message.success("Your application has been submitted.");
                onSubmitted?.();
                onClose();
            })
            .catch(() => message.error("We couldn't submit your application. Please try again."))
            .finally(() => setSubmitting(false));*/}
    };

    return (
        <Modal
            title={vacancy ? `Apply — ${vacancy.title}` : "Apply"}
            open={open}
            onCancel={onClose}
            onOk={() => form.submit()}
            okText="Submit application"
            confirmLoading={submitting}
            destroyOnClose
        >


            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    name="full_names"
                    label="Full name(s) (as on ID/passport)"
                    rules={[{ required: true, message: "Please enter your full name(s) as on your ID or passport" }]}
                >
                    <Input placeholder="e.g. Thabo Sipho" />
                </Form.Item>

                <Form.Item
                    name="surname"
                    label="Surname (as on ID/passport)"
                    rules={[{ required: true, message: "Please enter your surname" }]}
                >
                    <Input placeholder="e.g. Nkosi" />
                </Form.Item>

                <Form.Item
                    name="is_sa_citizen"
                    label="Are you a South African citizen?"
                    rules={[{ required: true, message: "Please select an option" }]}
                >
                    <Radio.Group>
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    noStyle
                    shouldUpdate={(prev, cur) => prev.is_sa_citizen !== cur.is_sa_citizen}
                >
                    {({ getFieldValue }) => (
                        <Form.Item
                            name="id_or_passport_number"
                            label={getFieldValue("is_sa_citizen") === false ? "Passport number" : "ID number"}
                            rules={[{ required: true, message: "Please enter your ID or passport number" }]}
                        >
                            <Input placeholder={getFieldValue("is_sa_citizen") === false ? "Passport number" : "13-digit SA ID number"} />
                        </Form.Item>
                    )}
                </Form.Item>

                <Form.Item
                    name="has_drivers_licence"
                    label="Do you have a driver's licence?"
                    rules={[{ required: true, message: "Please select an option" }]}
                >
                    <Radio.Group>
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    name="address"
                    label="Residential address"
                    rules={[{ required: true, message: "Please enter your residential address" }]}
                >
                    <Input.TextArea rows={3} placeholder="Street, suburb, town, province" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default JobApplicationModal;